import React, {useEffect, useState} from 'react';
import {
    ReactComponent as CalendarIcon
} from '../../../../../../../assets/main/groups/main-table/period-calendar/calendar.svg';
import {ReactComponent as FileIcon} from '../../../../../../../assets/main/groups/form/file.svg';
import {ReactComponent as CloseIcon} from '../../../../../../../assets/header/сlose.svg';
import {useFormik} from "formik";
import '../../add-lesson/form/form.css'

import TextArea from "antd/es/input/TextArea";
import {DatePicker, message} from "antd";
import {DatePickerProps, RangePickerProps} from "antd/es/date-picker";
import dayjs, {Dayjs} from "dayjs";
import {useFileUpload} from "common/hook/use-file-upload";
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {useAppDispatch, useAppSelector} from "common/hook";
import {LessonFile} from "features/model/types/lessosnSchema";
import {fetchUpdateLesson} from "features/model/service/lessons/edit-lesson/fetchUpdateLesson";
import {useNavigate, useParams} from "react-router-dom";
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'
import {fetchDeleteLessonFile} from "features/model/service/lessons/delete-lessons-file/fetchDeleteLessonFile";
import {fetchDeleteHomeworkFile} from "features/model/service/lessons/delete-lessons-file/fetchDeleteHomeworkFile";
import {clearError, setErrors} from "features/model/slice/groups/set-lessons/setLessons";
import {isAllOf} from "@reduxjs/toolkit";
import utc from 'dayjs/plugin/utc';

dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(utc);


interface Lesson {
    title: string;
    files: LessonFile[];
    homeworkFiles: LessonFile[];
    description: string;
    status: string;
    startAt: string;
    finishAt: string;
    link: string;
    homework: string;
    hasHomework: boolean;
    published: boolean;
}


export const EditLessonForm = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {lessonsId} = useParams();
    const lessonData = useAppSelector(state => state.lessons.items)
    const groupId = lessonData.map(lesson => lesson.group.id);
    const {success, errors, error,} = useAppSelector(state => state.lessons);
    const firstLesson = lessonData[0];
    const [firstLessonFiles, setFirstLessonFiles] = useState(firstLesson?.files || []);
    const [firstLessonHomeworkFiles, setFirstLessonHomeworkFiles] = useState(firstLesson?.homeworkFiles || []);

    const [startDate, setStartDate] = useState<Dayjs | null>(null)
    const [endDate, setEndDate] = useState<Dayjs | null>(null)

    useEffect(() => {
        return () => {
            dispatch(setErrors({success: false, error: '', errors: {}}));
        };
    }, [dispatch])


    const handleFileRemove = async (filePath: string, deleteType: 'lesson' | 'homework') => {
        try {
            const fetchAction = deleteType === 'lesson' ? fetchDeleteLessonFile : fetchDeleteHomeworkFile;
            const setFilesCallback = deleteType === 'lesson' ? setFirstLessonFiles : setFirstLessonHomeworkFiles;

            // Remove the file from the state before sending the request to the server
            setFilesCallback((prevFiles) => prevFiles.filter((file) => file.path !== filePath));

            const response = await dispatch(fetchAction({lessonId: lessonsId, filePath}));

            if (fetchAction.fulfilled.match(response)) {

            } else if (fetchAction.rejected.match(response)) {
                const errorMessage = response.payload;
                console.error("Error deleting file:", errorMessage);

                setFilesCallback((prevFiles) =>
                    prevFiles.filter((file) => file.path !== filePath) as LessonFile[]
                );
            }
        } catch (error) {
            console.error("An error occurred:", error);
            // Handle other errors if they occur
        }
    };


    const successMessageError = () => {
        message.error(error);
    };

    const successMessageTrue = () => {
        message.success('Занятие успешно изменено');
    };


    const {
        isFilled,
        handleFocus,
        handleBlur
    } = useInputWithFocus([false, false, false, false, false, false, false, false, false, false]);


    useEffect(() => {
        if (firstLesson) {
            const filesFromServer = firstLesson.files;
            const homeworkFilesFromServer = firstLesson.homeworkFiles;

            if (Array.isArray(filesFromServer)) {
                setFirstLessonFiles(filesFromServer);
            }

            if (Array.isArray(homeworkFilesFromServer)) {
                setFirstLessonHomeworkFiles(homeworkFilesFromServer);
            }
        }
    }, [lessonData]);

    useEffect(() => {
        if (success) {
            dispatch(setErrors({success: false, error: '', errors: {}}));
            successMessageTrue();
            if (success && lessonsId) {
                navigate(`/groups/${groupId}/lessons/${lessonsId}`);
            }
        }
    }, [success, dispatch, lessonsId]);


    // Блок 1
    const {
        drag: drag1,
        fileNames: fileNames1,
        fileInputRef: fileInputRef1,
        handleFileUpload: handleFileUpload1,
        handleFileRemove: handleFileRemove1,
        handleFileChange: handleFileChange1,
        dragStartHandler: dragStartHandler1,
        dragLeaveHandler: dragLeaveHandler1,
        onDropHandler: onDropHandler1,
        uploadedFiles: uploadedFiles1,
    } = useFileUpload();

    // Блок 2
    const {
        drag: drag2,
        fileNames: fileNames2,
        fileInputRef: fileInputRef2,
        handleFileUpload: handleFileUpload2,
        handleFileRemove: handleFileRemove2,
        handleFileChange: handleFileChange2,
        dragStartHandler: dragStartHandler2,
        dragLeaveHandler: dragLeaveHandler2,
        onDropHandler: onDropHandler2,
        uploadedFiles: uploadedFiles2,
    } = useFileUpload();


    const formik = useFormik<Lesson>({
        initialValues: {
            title: firstLesson?.title || '',
            files: firstLesson?.files || [],
            homeworkFiles: firstLesson?.homeworkFiles || [],
            description: firstLesson?.description || '',
            status: firstLesson?.status || '',
            startAt: firstLesson?.startAt || '',
            finishAt: firstLesson?.finishAt || '',
            link: firstLesson?.link || '',
            homework: firstLesson?.homework || '',
            hasHomework: firstLesson?.hasHomework || false,
            published: firstLesson?.published || false,
        },
        enableReinitialize: true,
        onSubmit: async (values, {resetForm}) => {
            resetForm();
        },
    });


    const handleReset = () => {
        // Reset formik values
        formik.resetForm();
        setFirstLessonFiles([])
        setFirstLessonHomeworkFiles([])
        navigate(`/groups/${groupId}/lessons/${lessonsId}`);
    };


    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append("title", formik.values.title);
        formData.append("description", formik.values.description);
        if (groupId !== undefined) {
            formData.append("group_id", groupId.toString());
        }
        formData.append("status", formik.values.status);

        // Проверяем и форматируем startAt
        const startAt = formik.values.startAt ? dayjs(formik.values.startAt).format("YYYY-MM-DD HH:mm") : '';
        formData.append("start_at", startAt);

        // Проверяем и форматируем finishAt
        const finishAt = formik.values.finishAt ? dayjs(formik.values.finishAt).format("YYYY-MM-DD HH:mm") : '';
        formData.append("finish_at", finishAt);

        formData.append("homework", formik.values.homework);
        formData.append("has_homework", formik.values.hasHomework.toString());
        formData.append("published", formik.values.published.toString());

        const combinedFiles = [...uploadedFiles1, ...firstLessonFiles];

        if (combinedFiles.length > 0) {
            combinedFiles.forEach((file) => {
                if ('path' in file) {
                    const textData = JSON.stringify(file);
                    const blob = new Blob([textData], {type: 'application/json'});
                    formData.append('files[]', blob, file.fileName);
                } else if (file instanceof File) {
                    // Это уже File, можно добавить его как есть
                    formData.append('files[]', file);
                }
            });
        }

        const combinedHomeworkFiles = [...uploadedFiles2, ...firstLessonHomeworkFiles];

        if (combinedHomeworkFiles.length > 0) {
            combinedHomeworkFiles.forEach((file) => {
                if ('path' in file) {
                    const textData = JSON.stringify(file);
                    const blob = new Blob([textData], {type: 'application/json'});
                    formData.append('homework_files[]', blob, file.fileName);
                } else if (file instanceof File) {
                    formData.append('homework_files[]', file);
                }
            });
        }

        try {
            await dispatch(fetchUpdateLesson({lessonsId, formData}));
        } catch (error) {
            successMessageError();
        }
    };

    const onOk = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        formik.setFieldValue('startAt', value);
    };
    const onOk1 = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        formik.setFieldValue('finishAt', value);
    };

    
    useEffect(() => {
        if (firstLesson?.startAt) {
            setStartDate(dayjs(firstLesson.startAt))
        }
        if (firstLesson?.finishAt) {
            setEndDate(dayjs(firstLesson.finishAt))
        }
    }, [firstLesson]);

    const handleTitleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(clearError("title"));
        formik.handleChange(e);
    };


    return (
        <div className="create-lesson-box">
            <p className="h4 box-title padding">Занятие</p>

            <form className="form" onSubmit={handleSubmit}>
                <div className="fields-row" style={{position: "relative"}}>
                    <div
                        className={`field required ${isFilled[0] ? 'filled' : ''} ${errors?.title ? 'error-field' : ''}`}>
                        <label
                            className={`field-name ${formik.values.title ? 'active-label' : ''}`}
                        >
                            Название занятия
                        </label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className={`form-control has-icon datepicker ${formik.values.status === "finished" ? "disabled" : ""}`}
                                id="title"
                                name="title"
                                value={formik.values.title}
                                onChange={handleTitleInputChange}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                                disabled={formik.values.status === "finished"}
                            />
                        </div>
                    </div>
                    {errors?.title && <p className="field-error">{errors?.title}</p>}
                </div>

                <div className="fields-row two-cols">
                    <div
                        className={`field has-icon-inp ${isFilled[1] ? "filled" : ""}${errors?.start_at ? 'error-field' : ''}`}>
                        <label
                            className={`field-name ${formik.values.startAt ? 'active-label' : ''}`}>Дата и время
                            начала</label>
                        <div className="inp-box">
                            <DatePicker
                                style={{cursor: 'pointer', caretColor: 'transparent', overflow: 'visible'}}
                                className={`form-control ${formik.values.status === "finished" ? "disabled" : ""}`}
                                placeholder={''}
                                value={startDate}
                                suffixIcon={<span className="icon-date"><CalendarIcon/></span>}
                                showTime={{format: 'HH:mm'}}
                                onChange={(value) => {
                                    if(errors.finish_at) {
                                        dispatch(clearError("start_at"))
                                    }
                                    setStartDate(value); // Обновляем состояние при изменении
                                }}
                                onFocus={() => handleFocus(1)}
                                onBlur={handleBlur}
                                inputReadOnly={true}
                                format="DD-MM-YYYY HH:mm"
                                onOk={onOk}
                            />
                        </div>
                        {errors?.start_at && <p className="field-error">{errors?.start_at}</p>}
                    </div>
                    <div
                        className={`field has-icon-inp ${isFilled[2] ? 'filled' : ''} ${errors?.start_at || errors?.finish_at ? 'error-field' : ''}`}>
                        <label
                            className={`field-name ${formik.values.finishAt ? 'active-label' : ''}`}
                        >
                            Дата и время окончания</label>
                        <div style={{border: '1px solid #red'}} className="inp-box">
                            <DatePicker
                                style={{cursor: 'pointer', caretColor: 'transparent', overflow: 'visible'}}
                                className={`form-control ${formik.values.status === "finished" ? "disabled" : ""}`}
                                placeholder={''}
                                value={endDate}

                                suffixIcon={<span className="icon-date"><CalendarIcon/></span>}
                                showTime={{format: 'HH:mm'}}
                                onChange={(value) => {
                                    if(errors.finish_at) {
                                        dispatch(clearError("finish_at"))
                                    }
                                    setEndDate(value)
                                }}
                                onFocus={() => handleFocus(2)}
                                onBlur={handleBlur}
                                inputReadOnly={true}
                                format="DD-MM-YYYY HH:mm"
                                onOk={onOk1}
                            />
                        </div>
                        {errors?.finish_at && <p className="field-error">{errors?.finish_at}</p>}
                    </div>
                </div>
                <div className="fields-row">
                    <div className={`field ${isFilled[3] ? 'filled' : ''}`}>
                        <label
                            className={`field-name ${formik.values.description ? 'active-label' : ''}`}
                        >
                            Описание занятия
                        </label>
                        <div className="textarea-box">
                            <TextArea
                                className={`form-control has-icon ${formik.values.status === "finished" ? "disabled" : ""}`}
                                id="description"
                                name="description"
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(3)}
                                onBlur={handleBlur}
                                autoSize={{minRows: 3, maxRows: 15}}
                                disabled={formik.values.status === "finished"}
                            />
                        </div>
                    </div>
                </div>
                <div className="fields-row">
                    <div className="field">
                        {drag1 ?
                            <div
                                onDragStart={(e) => dragStartHandler1(e)}
                                onDragLeave={(e) => dragLeaveHandler1(e)}
                                onDragOver={(e) => dragStartHandler1(e)}
                                onDrop={(e) => onDropHandler1(e)}
                                onClick={handleFileUpload1}
                                className="upload-box upload-box-drop"
                            >
                                <p>Отпустите файл, чтобы загрузить его</p>
                            </div> :
                            <div className="upload-box">
                                <div
                                    onDragStart={(e) => dragStartHandler1(e)}
                                    onDragLeave={(e) => dragLeaveHandler1(e)}
                                    onDragOver={(e) => dragStartHandler1(e)}
                                    onDrop={(e) => onDropHandler1(e)}
                                    className="form-button"
                                    onClick={handleFileUpload1}
                                >
                                    <FileIcon/>
                                    <p
                                        onDragStart={(e) => dragStartHandler1(e)}
                                        onDragLeave={(e) => dragLeaveHandler1(e)}
                                        onDragOver={(e) => dragStartHandler1(e)}
                                        onDrop={(e) => onDropHandler1(e)}
                                    >
                                        Перетащите файл сюда или <a>выберите файл</a>
                                    </p>
                                </div>

                                <input
                                    id="fileupload"
                                    type="file"
                                    name="fileupload"
                                    ref={fileInputRef1}
                                    style={{display: "none"}}
                                    onChange={handleFileChange1}
                                    multiple={true}
                                />
                            </div>
                        }
                        <div className="uploaded-files">
                            {firstLesson && firstLesson.files && firstLesson.files[0] && (
                                <ul className="uploaded-files-list">
                                    {firstLessonFiles.map((fileName) => {
                                        return (
                                            <li key={fileName.path}>
                                            <span className="js-remove-file"
                                                  onClick={() => handleFileRemove(fileName.path, 'lesson')}
                                            >
                                                <CloseIcon/>
                                            </span>
                                                <div className="file-name">
                                                    <span>{fileName.fileName}</span>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            )}
                        </div>
                        <div className="uploaded-files">
                            <ul className="uploaded-files-list">
                                {fileNames1.map((fileName, index) => (
                                    <li key={index}>
                                            <span className="js-remove-file"
                                                  onClick={() => handleFileRemove1(index)}>
                                                <CloseIcon/>
                                            </span>
                                        <div className="file-name">
                                            <span>{fileName}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="fields-row">
                    <div className="field">
                        <div className="switch-box">
                            <label className="h4" htmlFor="hasHomework">
                                Домашнее задание
                            </label>
                            <div className="switch-btn">
                                <input
                                    id="hasHomework"
                                    type="checkbox"
                                    name="hasHomework"
                                    checked={formik.values.hasHomework}
                                    onChange={formik.handleChange}
                                />
                                <label htmlFor="hasHomework" className="tooltip"></label>
                            </div>
                        </div>
                    </div>
                </div>
                {formik.values.hasHomework && (
                    <>
                        <div className="fields-row">
                            <div className={`field ${isFilled[4] ? 'filled' : ''}`}>
                                <label
                                    className={`field-name ${formik.values.homework ? 'active-label' : ''}`}
                                >
                                    Описание домашнего задания</label>
                                <div className="textarea-box">
                                    <TextArea
                                        className="form-control"
                                        id="homework"
                                        name="homework"
                                        value={formik.values.homework}
                                        onChange={formik.handleChange}
                                        onFocus={() => handleFocus(4)}
                                        onBlur={handleBlur}
                                        autoSize={{minRows: 3, maxRows: 15}}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="fields-row">
                            <div className="field">
                                {drag2 ?
                                    <div
                                        onDragStart={(e) => dragStartHandler2(e)}
                                        onDragLeave={(e) => dragLeaveHandler2(e)}
                                        onDragOver={(e) => dragStartHandler2(e)}
                                        onDrop={(e) => onDropHandler2(e)}
                                        onClick={handleFileUpload2}
                                        className="upload-box upload-box-drop"
                                    >
                                        <p>Отпустите файл, чтобы загрузить его</p>
                                    </div> :
                                    <div className="upload-box">
                                        <div
                                            onDragStart={(e) => dragStartHandler2(e)}
                                            onDragLeave={(e) => dragLeaveHandler2(e)}
                                            onDragOver={(e) => dragStartHandler2(e)}
                                            onDrop={(e) => onDropHandler2(e)}
                                            className="form-button"
                                            onClick={handleFileUpload2}
                                        >
                                            <FileIcon/>
                                            <p
                                                onDragStart={(e) => dragStartHandler2(e)}
                                                onDragLeave={(e) => dragLeaveHandler2(e)}
                                                onDragOver={(e) => dragStartHandler2(e)}
                                                onDrop={(e) => onDropHandler2(e)}
                                            >
                                                Перетащите файл сюда или <a>выберите файл</a>
                                            </p>
                                        </div>

                                        <input
                                            id="filehomework"
                                            type="file"
                                            name="filehomework"
                                            ref={fileInputRef2}
                                            style={{display: "none"}}
                                            onChange={handleFileChange2}
                                            multiple={true}
                                        />
                                    </div>
                                }
                                <div className="uploaded-files">
                                    {firstLesson && firstLesson.homeworkFiles && firstLesson.homeworkFiles[0] && (
                                        <ul className="uploaded-files-list">
                                            {firstLessonHomeworkFiles.map((fileName) => {
                                                return (
                                                    <li key={fileName.path}>
                                                     <span className="js-remove-file"
                                                           onClick={() => handleFileRemove(fileName.path, 'homework')}
                                                     >
                                                         <CloseIcon/>
                                                     </span>
                                                        <div className="file-name">
                                                            <span>{fileName.fileName}</span>
                                                        </div>
                                                    </li>
                                                )
                                            })}

                                        </ul>
                                    )}
                                </div>
                                <div className="uploaded-files">
                                    <ul className="uploaded-files-list">
                                        {fileNames2.map((fileName, index) => (
                                            <li key={index}>1
                                                <span className="js-remove-file"
                                                      onClick={() => handleFileRemove2(index)}>
                                                        <CloseIcon/>
                                                     </span>
                                                <div className="file-name">
                                                    <span>{fileName}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </>
                )}


                <div className="btns-box aside-btns">
                    <div className="col sub-col">
                        <div className="switch-box">
                            <label htmlFor="published">
                                Опубликовать занятие и открыть доступ в группе
                            </label>
                            <div className="switch-btn">
                                <input
                                    id="published"
                                    type="checkbox"
                                    checked={formik.values.published}
                                    onChange={formik.handleChange}
                                />
                                <label htmlFor="published" className="tooltip"></label>
                            </div>
                        </div>
                    </div>
                    <div className="col btns-col">
                        <button type="button" className="btn secondary" onClick={handleReset}>
                            <span>Отменить</span>
                        </button>
                        <button type="submit" className="btn">
                            <span>Редактировать занятие</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};
